const { generateId } = require('@appblocks/utils');

function getFeature(id, features) {
    const currentFeatures = features;
    for (let i = 0; i < currentFeatures.length; i += 1) {
        const feature = currentFeatures[i];
        if (feature.settings.ID === id) {
            return feature;
        }
        const keys = Object.keys(feature.settings);
        for (let j = 0; j < keys.length; j++) {
            const key = keys[j];
            if (Array.isArray(feature.settings[key])) {
                const tmp = getFeature(id, feature.settings[key]);
                if (tmp !== undefined) {
                    return tmp;
                }
            }
        }
    }
    return undefined;
}

function getVariable(variableName, features) {
    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (feature.id === 'global_vars') {
            const variables = feature.settings.VARS.concat(feature.settings.AUTOVARS);
            for (let j = 0; j < variables.length; j++) {
                const variable = variables[j];
                if (variable.settings.VARNAME === variableName) {
                    return variable;
                }
            }
        }
    }
    return undefined;
}

export const migrations = [
    {
        from: '0.1.3',
        to: '0.1.4',
        migrate: (project) => {

        },
    },
    {
        from: '0.1.4',
        to: '0.1.5',
        migrate: (project) => {
            const features = project.features;
            const toDictionary = (feature) => {
                const settings = feature.settings;
                if (Array.isArray(settings)) {
                    const dict = {};
                    for (let i = 0; i < settings.length; i++) {
                        const setting = settings[i];
                        if (Array.isArray(setting.value)) {
                            const tmp = [];
                            for (let j = 0; j < setting.value.length; j++) {
                                const value = setting.value[j];
                                tmp.push(toDictionary(value));
                            }
                            dict[setting.id] = tmp;
                        } else if (typeof setting.value === 'object') {
                            dict[setting.id] = toDictionary(setting.value);
                        } else {
                            dict[setting.id] = setting.value;
                        }
                    }
                    feature.settings = dict;
                }
                return feature;
            };

            for (let i = 0; i < features.length; i++) {
                const feature = features[i];
                const settings = feature.settings;
                if (Array.isArray(settings)) {
                    const dict = {};
                    for (let i = 0; i < settings.length; i++) {
                        const setting = settings[i];
                        if (Array.isArray(setting.value)) {
                            const tmp = [];
                            for (let j = 0; j < setting.value.length; j++) {
                                const value = setting.value[j];
                                tmp.push(toDictionary(value));
                            }
                            dict[setting.id] = tmp;
                        } else if (typeof setting.value === 'object') {
                            dict[setting.id] = toDictionary(setting.value);
                        } else {
                            dict[setting.id] = setting.value;
                        }
                    }
                    feature.settings = dict;
                }
            }
        },
    },
    {
        from: '0.1.5',
        to: '0.1.6',
        migrate: (project) => {
            let stg = {};
            let settings = [];
            let links = [];
            for (let j = 0; j < project.features.length; j++) {
                if (project.features[j].id === 'stg') {
                    stg = project.features[j];
                    settings = stg.settings.SETTINGS;
                }
                if (project.features[j].id === 'ds_man') {
                    for (let k = 0; k < project.features[j].settings.GROUPS.length; k++) {
                        links = links
                            .concat(project.features[j].settings.GROUPS[k].settings.SETTINGS);
                    }
                }
                if (project.features[j].id === 'lcd_menu') {
                    for (let k = 0; k < project.features[j].settings.GROUPS.length; k++) {
                        links = links
                            .concat(project.features[j].settings.GROUPS[k].settings.SETTINGS);
                    }
                }
                if (project.features[j].id === 'luis') {
                    for (let k = 0; k < project.features[j].settings.GROUPS.length; k++) {
                        links = links
                            .concat(project.features[j].settings.GROUPS[k].settings.SETTINGS);
                    }
                }
                if (project.features[j].id === 'linked_setting') {
                    links.push(project.features[j]);
                }
            }
            for (let i = 0; i < links.length; i++) {
                const feature = links[i];
                let SETTINGID = feature.settings.LINKEDSETTING;
                if (feature.id !== 'linked_setting') {
                    SETTINGID = feature.settings.SETTINGID;
                }
                let newSettingId = SETTINGID;
                for (let j = 0; j < settings.length; j++) {
                    const tmpSettingFeature = settings[j];
                    if (tmpSettingFeature.settings.SETTINGID === SETTINGID) {
                        newSettingId = tmpSettingFeature.settings.ID;
                        break;
                    }
                }
                const linkedStg = getFeature(feature.settings.ID, project.features);
                linkedStg.settings.LINKEDSETTING = newSettingId;
                // projectObject.getFeature(feature.settings.ID)
                // .setSettingValue('LINKEDSETTING', newSettingId);
                if (feature.id !== 'linked_setting') {
                    // projectObject.getFeature(feature.settings.ID)
                    // .setSettingValue('SETTINGID', newSettingId);
                    const linkedStg2 = getFeature(feature.settings.ID, project.features);
                    linkedStg2.settings.SETTINGID = newSettingId;
                }
            }
        },
    },
    {
        from: '0.1.6',
        to: '0.1.7',
        migrate: (project) => {
            // link to variables to use feature id instead of VARNAME

            for (let j = 0; j < project.features.length; j++) {
                const feature = project.features[j];
                if (feature.id !== 'node_link' && feature.id.indexOf('node_') === 0) {
                    const args = feature.settings.ARGUMENTS;
                    for (let i = 0; i < args.length; i++) {
                        const argument = args[i];
                        const regex = /{{\$([A-Za-z0-9-_]+)}}/g;
                        let m = regex.exec(argument.settings.ARGVALUE);
                        while (m !== null) {
                            if (m.index === regex.lastIndex) {
                                regex.lastIndex += 1;
                            }
                            const match = m[1];
                            const variable = getVariable(match, project.features);
                            if (variable !== undefined) {
                                argument.settings.ARGVALUE = argument.settings.ARGVALUE.replace(`{{$${match}}}`, `{{$${variable.settings.ID}}}`);
                            }

                            m = regex.exec(argument.settings.ARGVALUE);
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.7',
        to: '0.1.8',
        migrate: (project) => {
            for (let j = 0; j < project.features.length; j++) {
                const feature = project.features[j];
                if (feature.id === 'cron') {
                    const schedules = feature.settings.SCHEDULES;
                    for (let i = 0; i < schedules.length; i++) {
                        const schedule = schedules[i];
                        const pattern = schedule.settings.PATTERN;
                        if (pattern.split(' ').length === 5) {
                            schedule.settings.PATTERN = `${pattern} *`;
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.8',
        to: '0.1.9',
        migrate: (project) => {
            for (let j = 0; j < project.features.length; j++) {
                const feature = project.features[j];
                if (feature.id === 'tbl') {
                    const tables = feature.settings.TABLES;
                    for (let i = 0; i < tables.length; i++) {
                        const table = tables[i];
                        for (let k = 0; k < table.settings.FIELDS.length; k++) {
                            const field = table.settings.FIELDS[k];
                            field.settings.COMMENT = field.settings.NAME;
                            field.settings.DISPLAY_NAME = field.settings.COMMENT;
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.9',
        to: '0.1.10',
        migrate: (project) => {
            for (let j = 0; j < project.features.length; j++) {
                const feature = project.features[j];
                if (feature.id === 'node_table') {
                    const args = feature.settings.ARGUMENTS;
                    let found = false;
                    for (let i = 0; i < args.length; i++) {
                        const argument = args[i];
                        if (argument.settings.TARGETPARAM === 'find_index') {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        feature.settings.ARGUMENTS.push({
                            id: 'node_argument',
                            settings: {
                                ID: generateId(),
                                ARGVALUE: '0',
                                TARGETPARAM: 'find_index',
                            },
                        });
                    }
                }
            }
        },
    },
    {
        from: '0.1.10',
        to: '0.1.11',
        migrate: (project) => {
            for (let j = 0; j < project.features.length; j++) {
                const feature = project.features[j];
                if (feature.id === 'modbus_master') {
                    const devices = feature.settings.MODBUSDEVICES;
                    for (let i = 0; i < devices.length; i++) {
                        const device = devices[i];
                        if (device.settings.SERIAL_PORT !== '') {
                            let portID = device.settings.SERIAL_PORT;
                            const portName = portID.substring(portID.indexOf('SER_') + 4);
                            for (let k = 0; k < project.features.length; k++) {
                                const feature2 = project.features[k];
                                if (feature2.settings.MODE === 'RS485') {
                                    if (feature2.settings.NAME === portName) {
                                        portID = feature2.settings.ID;
                                    }
                                    break;
                                }
                            }
                            device.settings.SERIAL_PORT = portID;
                        }
                    }
                } else if (feature.id === 'modbus_slave') {
                    let portID = feature.settings.SLAVE_SERIAL_PORT;
                    const portName = portID.substring(portID.indexOf('SER_') + 4);
                    for (let k = 0; k < project.features.length; k++) {
                        const feature2 = project.features[k];
                        if (feature2.settings.MODE === 'RS485') {
                            if (feature2.settings.NAME === portName) {
                                portID = feature2.settings.ID;
                            }
                            break;
                        }
                    }
                    feature.settings.SLAVE_SERIAL_PORT = portID;
                }
            }
        },
    },
    {
        from: '0.1.11',
        to: '0.1.12',
        migrate: (project) => {
            // migrate widgets
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (feature.id === 'web_dashboard') {
                    const newWidgets = [];
                    const widgets = JSON.parse(feature.settings.WIDGETS);
                    for (let j = 0; j < widgets.length; j++) {
                        const widget = widgets[j];
                        const newWidget = {
                            id: 'widget',
                            settings: {
                                ID: generateId(),
                                VARIABLE: widget?.variable,
                                TYPE: widget?.type,
                                X: widget?.x,
                                Y: widget?.y,
                                W: widget?.w,
                                H: widget?.h,
                                LABEL: widget.settings?.label,
                                MIN: widget.settings?.min,
                                MAX: widget.settings?.max,
                                NAME: widget?.name,
                                DECIMAL_PLACES: widget.settings?.decimalPlaces,
                                VALUES: widget.settings?.values,
                                CUSTOM_FN: widget.settings?.customFn,
                                BOUNDS: widget.settings?.bounds,
                                HAS_INPUT: widget.settings?.hasInput ? '1' : '0',
                                ON_VALUE: widget.settings?.onValue,
                                OFF_VALUE: widget.settings?.offValue,
                                ON_LABEL: widget.settings?.onLabel,
                                OFF_LABEL: widget.settings?.offLabel,
                                IS_ON: widget.settings?.isOn ? '1' : '0',
                                IS_HORIZONTAL: widget.settings?.isHorizontal ? '1' : '0',
                            },
                        };
                        newWidgets.push(newWidget);
                    }
                    project.features[i].settings.WIDGETS = newWidgets;
                }
            }
        },
    },
    {
        from: '0.1.12',
        to: '0.1.13',
        migrate: (project) => {
            // migrate widgets
            const renamedWidgets = [
                'tibbit_28',
                'tibbit_29',
                'tibbit_35',
                'tibbit_38',
                'tibbit_41',
            ];
            const renamedWidgetMap = {
                tibbit_28: {
                    NAME: 'LIGHT_NAME',
                },
                tibbit_29: {
                    NAME: 'TEMP_NAME',
                },
                tibbit_35: {
                    NAME: 'PRESSURE_NAME',
                },
                tibbit_38: {
                    NAME: 'BUTTON_NAME',
                },
                tibbit_41: {
                    NAME: 'PORT_NAME',
                },
            };
            const renamedVariables = {};
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (renamedWidgets.includes(feature.id)) {
                    feature.settings[renamedWidgetMap[feature.id].NAME] = feature.settings.NAME;
                    renamedVariables[feature.settings.ID] = {
                        name: feature.settings.NAME,
                        featureType: feature.id,
                    };
                    delete feature.settings.NAME;
                }
            }
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (feature.id === 'global_vars') {
                    const variables = feature.settings.VARS.concat(feature.settings.AUTOVARS);
                    for (let j = 0; j < variables.length; j++) {
                        const variable = variables[j];
                        if (variable.settings.FEATURE !== undefined
                            && renamedVariables[variable.settings.FEATURE] !== undefined) {
                            variable.settings.VARNAME = renamedVariables[variable.settings.FEATURE]
                                .name;
                            variable.settings.FEATURE_SETTING = renamedWidgetMap[
                                renamedVariables[variable.settings.FEATURE]
                                    .featureType
                            ][variable.settings.FEATURE_SETTING];
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.13',
        to: '0.1.14',
        migrate: (project) => {
            const renamedVariables = {};
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (feature.settings.GROUPS !== undefined) {
                    const groups = feature.settings.GROUPS;
                    for (let j = 0; j < groups.length; j++) {
                        const group = groups[j];
                        if (group.settings.GROUPID !== undefined) {
                            group.settings.GROUPID = group.settings.GROUPID.replace('_', '');
                        }
                        if (group.settings.ITEMID !== undefined) {
                            group.settings.ITEMID = group.settings.ITEMID.replace('_', '');
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.14',
        to: '0.1.15',
        migrate: (project) => {
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (feature.id === 'ds_man') {
                    const groups = feature.settings.GROUPS;
                    for (let j = 0; j < groups.length; j++) {
                        const group = groups[j];
                        if (group.id === 'ds_group') {
                            group.id = 'luis_group';
                            group.settings.GROUPID = group.settings.ITEMID.replace('group', 'dsgroup');
                            delete group.settings.ITEMID;
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.15',
        to: '0.1.16',
        migrate: (project) => {
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if ((feature.id === 'lcd'
                    || feature.id === 'web_dashboard')
                    && feature.settings.WIDGETS !== undefined) {
                    const widgets = feature.settings.WIDGETS;
                    for (let i = 0; i < widgets.length; i++) {
                        const widget = widgets[i];
                        const settings = widget.settings;
                        if (settings.TYPE) {
                            widget.id = `${settings.TYPE}_widget`;
                        }
                    }
                }
            }
        },
    },
    {
        from: '0.1.16',
        to: '0.1.17',
        migrate: (project) => {
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                const lcdFeatures = ['lcd', 'ssd1306', 'st7789', 'ds_oled'];
                // add default screen
                if (lcdFeatures.includes(feature.id) && feature.settings.WIDGETS !== undefined) {
                    let screens = feature.settings.SCREENS;
                    if (!screens) {
                        screens = [];
                    }
                    if (screens.length === 0) {
                        screens.push({
                            id: 'display_screen',
                            settings: {
                                ID: generateId(),
                                NAME: 'default',
                                WIDGETS: [
                                    ...feature.settings.WIDGETS,
                                ],
                            },
                        });
                    }
                    feature.settings.SCREENS = screens;
                    feature.settings.WIDGETS = [];
                }
            }
        },
    },
    {
        from: '0.1.17',
        to: '0.1.18',
        migrate: (project) => {
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                const serialFeatures = ['tibbit_05', 'tibbit_01', 'tibbit_02', 'tibbit_44_1', 'ser', 'ser232', 'ser422', 'ser485'];
                // add default screen
                if (serialFeatures.includes(feature.id)) {
                    const BAUD = feature.settings.BAUD;
                    if (BAUD.toString().length > 6) {
                        const parts = BAUD.toString().split('_');
                        feature.settings.BAUD = parts[parts.length - 1];
                    }
                    const FLOWCONTROL = feature.settings.FLOWCONTROL;
                    switch (FLOWCONTROL) {
                        case 'PL_SER_FC_DISABLED':
                            feature.settings.FLOWCONTROL = '0';
                            break;
                        case 'PL_SER_FC_RTSCTS':
                            feature.settings.FLOWCONTROL = '1';
                            break;
                        case 'PL_SER_FC_XONOFF':
                            feature.settings.FLOWCONTROL = '2';
                            break;
                        default:

                            break;
                    }
                    const PARITY = feature.settings.PARITY;
                    switch (PARITY) {
                        case 'PL_SER_PR_NONE':
                            feature.settings.PARITY = '0';
                            break;
                        case 'PL_SER_PR_ODD':
                            feature.settings.PARITY = '2';
                            break;
                        case 'PL_SER_PR_EVEN':
                            feature.settings.PARITY = '1';
                            break;
                        case 'PL_SER_PR_MARK':
                            feature.settings.PARITY = '3';
                            break;
                        case 'PL_SER_PR_SPACE':
                            feature.settings.PARITY = '4';
                            break;
                        default:

                            break;
                    }
                    const BITS = feature.settings.BITS;
                    switch (BITS) {
                        case 'PL_SER_BB_7':
                            feature.settings.BITS = '0';
                            break;
                        case 'PL_SER_BB_8':
                            feature.settings.BITS = '1';
                            break;
                        default:

                            break;
                    }
                }
            }
        },
    },
    {
        from: '0.1.18',
        to: '0.1.19',
        migrate: (project) => {
            // expose all tables in web_dashboard and cgg
            let tableItems = [];
            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if (feature.id === 'tbl') {
                    tableItems = feature.settings.TABLES;
                }
            }

            for (let i = 0; i < project.features.length; i++) {
                const feature = project.features[i];
                if ((feature.id === 'web_dashboard' || feature.id === 'cgg') && tableItems.length > 0) {
                    let TABLES = feature.settings.TABLES;
                    if (!TABLES) {
                        TABLES = [];
                    }
                    for (let j = 0; j < tableItems.length; j++) {
                        const table = tableItems[j];
                        if (table.settings.STRUCT === 'L') {
                            // skip log table types as they are automatically added
                            continue;
                        }
                        if (TABLES.filter(t => t.settings.TABLE === table.settings.ID).length > 0) {
                            continue;
                        }
                        TABLES.push({
                            id: 'console_table_item',
                            settings: {
                                ID: generateId(),
                                NAME: '',
                                TABLE: table.settings.ID,
                            },
                        });
                    }
                    feature.settings.TABLES = TABLES;
                }
            }
        },
    },
];

export const migrate = (inputProject, toVersion) => {
    const project = JSON.parse(JSON.stringify(inputProject));
    for (let i = 0; i < migrations.length; i += 1) {
        if (migrations[i].from === inputProject.version) {
            try {
                migrations[i].migrate(project);
                inputProject.version = migrations[i].to;
                if (toVersion !== undefined) {
                    if (inputProject.version === toVersion) {
                        break;
                    }
                }
            } catch (e) {
                console.log(`Migration failed for ${project.id} from ${migrations[i].from}`);
                console.log(e);
            }
        }
    }
    inputProject.features = project.features;
};
